import { FC } from 'react';
import { getCssVarValue } from '@mybonum/ui';
import { Flex } from 'antd';

import { AdminCreate } from '../create';

export const AdminsFilter: FC = () => {
    return (
        <Flex justify="end" gap={getCssVarValue('spacing-sm', true)} wrap="wrap">
            {/*<CustomSearchInput style={{ maxWidth: '450px' }} />*/}
            <AdminCreate />
        </Flex>
    );
};
